export const PAGE_DESCRIPTION = {
  notRegistered:
    'Мы рады приветствовать Вас на Главной странице Электронной тендерной площадки для агропромышленного комплекса, в том числе для группы компаний ТЕНДЕР. Данная система предназначена для повышения эффективности и удобства проведения торгов, а также для обеспечения доступности информации о существующих тендерах и возможности участия в них.',
}
